var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    _vm._b(
      {
        attrs: { width: "400px", persistent: "" },
        scopedSlots: _vm._u([
          {
            key: "activator",
            fn: function({ attrs }) {
              return [
                _c(
                  "v-btn",
                  _vm._b(
                    {
                      attrs: { color: "primary" },
                      on: { click: _setup.openCreateLog }
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  [_vm._v("Add Log")]
                )
              ]
            }
          }
        ]),
        model: {
          value: _setup.dialog,
          callback: function($$v) {
            _setup.dialog = $$v
          },
          expression: "dialog"
        }
      },
      "v-dialog",
      _setup.attrs,
      false
    ),
    [
      _c(
        "v-card",
        [
          !_setup.editConfig.isEdit
            ? _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", dense: "", flat: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _setup.closeDialog }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Create New Log")])
                ],
                1
              )
            : _c(
                "v-toolbar",
                {
                  attrs: {
                    dark: "",
                    color: "yellow darken-3",
                    dense: "",
                    flat: ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _setup.closeDialog }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                  _c("v-toolbar-title", [_vm._v("Edit Log")])
                ],
                1
              ),
          !_setup.editConfig.loading
            ? _c("v-container", [
                _c(
                  "div",
                  { staticClass: "log-form" },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: "Client",
                        outlined: "",
                        dense: "",
                        "item-value": "id",
                        "item-text": "name",
                        loading: _setup.customerServerActions.loading,
                        items: _setup.customerServerActions.list,
                        "hide-details": "auto",
                        "error-messages":
                          _setup.formServerActions.errors.customerId
                      },
                      on: { change: _setup.onCustomerChange },
                      model: {
                        value: _setup.formInputs.customerId,
                        callback: function($$v) {
                          _vm.$set(_setup.formInputs, "customerId", $$v)
                        },
                        expression: "formInputs.customerId"
                      }
                    }),
                    _c("v-combobox", {
                      attrs: {
                        label: "Elevator",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        loading: _setup.elevatorSuggestions.loading,
                        items: _setup.elevatorSuggestions.list,
                        "error-messages":
                          _setup.formServerActions.errors.elevator
                      },
                      model: {
                        value: _setup.formInputs.elevator,
                        callback: function($$v) {
                          _vm.$set(_setup.formInputs, "elevator", $$v)
                        },
                        expression: "formInputs.elevator"
                      }
                    }),
                    _c("v-autocomplete", {
                      attrs: {
                        label: "Status Start",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        "error-messages":
                          _setup.formServerActions.errors.statusBefore,
                        items: ["operational", "non-operational"]
                      },
                      model: {
                        value: _setup.formInputs.statusBefore,
                        callback: function($$v) {
                          _vm.$set(_setup.formInputs, "statusBefore", $$v)
                        },
                        expression: "formInputs.statusBefore"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Date Start",
                        type: "datetime-local",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        "error-messages":
                          _setup.formServerActions.errors.dateStart
                      },
                      model: {
                        value: _setup.formInputs.dateStart,
                        callback: function($$v) {
                          _vm.$set(_setup.formInputs, "dateStart", $$v)
                        },
                        expression: "formInputs.dateStart"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Actions",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        "error-messages":
                          _setup.formServerActions.errors.actions,
                        clearable: ""
                      },
                      model: {
                        value: _setup.formInputs.actions,
                        callback: function($$v) {
                          _vm.$set(_setup.formInputs, "actions", $$v)
                        },
                        expression: "formInputs.actions"
                      }
                    }),
                    _c("v-textarea", {
                      attrs: {
                        label: "Remarks",
                        outlined: "",
                        rows: "3",
                        dense: "",
                        "hide-details": "auto",
                        "error-messages":
                          _setup.formServerActions.errors.remarks,
                        clearable: ""
                      },
                      model: {
                        value: _setup.formInputs.remarks,
                        callback: function($$v) {
                          _vm.$set(_setup.formInputs, "remarks", $$v)
                        },
                        expression: "formInputs.remarks"
                      }
                    }),
                    _c("v-divider"),
                    _c("v-autocomplete", {
                      attrs: {
                        label: "Status End",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        "error-messages":
                          _setup.formServerActions.errors.statusAfter,
                        items: [
                          "non-selected",
                          "operational",
                          "non-operational"
                        ]
                      },
                      model: {
                        value: _setup.formInputs.statusAfter,
                        callback: function($$v) {
                          _vm.$set(_setup.formInputs, "statusAfter", $$v)
                        },
                        expression: "formInputs.statusAfter"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: "Date End",
                        type: "datetime-local",
                        outlined: "",
                        dense: "",
                        "hide-details": "auto",
                        "error-messages":
                          _setup.formServerActions.errors.dateEnd
                      },
                      model: {
                        value: _setup.formInputs.dateEnd,
                        callback: function($$v) {
                          _vm.$set(_setup.formInputs, "dateEnd", $$v)
                        },
                        expression: "formInputs.dateEnd"
                      }
                    }),
                    !_setup.editConfig.isEdit
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "primary",
                              loading: _setup.formServerActions.loading
                            },
                            on: { click: _setup.addLog }
                          },
                          [_vm._v("Add Log")]
                        )
                      : _c(
                          "v-btn",
                          {
                            attrs: {
                              color: "yellow darken-3",
                              dark: "",
                              elevation: "0",
                              loading: _setup.formServerActions.loading
                            },
                            on: { click: _setup.updateLog }
                          },
                          [_vm._v(" Update ")]
                        )
                  ],
                  1
                )
              ])
            : _c("v-container", [
                _c(
                  "div",
                  {
                    staticClass: "log-form",
                    staticStyle: { width: "100%", position: "relative" }
                  },
                  [
                    _c("v-skeleton-loader", {
                      attrs: {
                        type: "text, text, text, text, text, text, button",
                        "min-width": "100%"
                      }
                    })
                  ],
                  1
                )
              ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }